import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'REGISTER_FORM', {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  PHONE: 'Phone',
  EMAIL: 'Email',
  EMAIL_CONFIRMATION: 'Email confirmation',
  PASSWORD: 'Password',
  PASSWORD_CONFIRMATION: 'Password confirmation',
  SUBMIT_BUTTON: 'Register',
  LOGIN: 'Already have an account? Log in',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'REGISTER_FORM', {
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  PHONE: 'Celular',
  EMAIL: 'Email',
  EMAIL_CONFIRMATION: 'Confirmar email',
  PASSWORD: 'Contraseña',
  PASSWORD_CONFIRMATION: 'Confirmar contraseña',
  SUBMIT_BUTTON: 'Registrarse',
  LOGIN: 'Ya tenés una cuenta? Inicia sesión',
});
